/**
 * PostHog event names for MenuHunter web.
 * See apps/web/docs/posthog-taxonomy.md for firing semantics and properties.
 */

export const POSTHOG_EVENTS = {
  SCAN_PAGE_VIEWED: 'scan_page_viewed',
  SCAN_CTA_APP_STORE: 'scan_cta_app_store',
  SCAN_CTA_GOOGLE_PLAY: 'scan_cta_google_play',
  SCAN_CTA_RESTAURANT_CLAIM: 'scan_cta_restaurant_claim',
  ORGANIC_SEO_LANDING_VIEWED: 'organic_seo_landing_viewed',
  QR_SCAN_STARTED: 'qr_scan_started',
  QR_SCAN_COMPLETED: 'qr_scan_completed',
  MENU_CAPTURE_STARTED: 'menu_capture_started',
  MENU_CAPTURE_COMPLETED: 'menu_capture_completed',
  MENU_PREVIEW_VIEWED: 'menu_preview_viewed',
  MENU_PUBLISHED: 'menu_published',
  RESTAURANT_CLAIM_STARTED: 'restaurant_claim_started',
  RESTAURANT_CLAIM_COMPLETED: 'restaurant_claim_completed',
  PRICING_VIEWED: 'pricing_viewed',
  SUBSCRIPTION_CHECKOUT_STARTED: 'subscription_checkout_started',
  SUBSCRIPTION_CHECKOUT_COMPLETED: 'subscription_checkout_completed',
  OWNER_DASHBOARD_VIEWED: 'owner_dashboard_viewed',
  OWNER_QR_DOWNLOADED: 'owner_qr_downloaded',
  OWNER_QR_PARTNER_CLICKED: 'owner_qr_partner_clicked',
  OWNER_QR_PARTNER_CODE_COPIED: 'owner_qr_partner_code_copied',
  SHARED_LIST_PUBLIC_OPENED: 'shared_list_public_opened',
  MEAL_POLL_CREATED: 'meal_poll_created',
  MEAL_POLL_SHARED: 'meal_poll_shared',
  MEAL_POLL_VOTE_CAST: 'meal_poll_vote_cast',
  MEAL_POLL_VOTE_CHANGED: 'meal_poll_vote_changed',
  SUPPORT_TICKET_REPLY_SENT: 'support_ticket_reply_sent',
  SUPPORT_TICKET_STATUS_CHANGED: 'support_ticket_status_changed',
  EXPLORE_PAGE_VIEWED: 'explore_page_viewed',
  MAP_VIEWPORT_LOADED: 'map_viewport_loaded',
  MAP_MARKER_SELECTED: 'map_marker_selected',
  RESTAURANT_CARD_CLICKED: 'restaurant_card_clicked',
  MENU_DETAIL_VIEWED: 'menu_detail_viewed',
  SEARCH_PERFORMED: 'search_performed',
  FAVORITE_ADDED: 'favorite_added',
  FAVORITE_REMOVED: 'favorite_removed',
  APP_DOWNLOAD_CTA_CLICKED: 'app_download_cta_clicked',
  PWA_INSTALL_PROMPTED: 'pwa_install_prompted',
  PWA_INSTALLED: 'pwa_installed',
  COMPLIMENTARY_PRO_PROGRESS_VIEWED: 'complimentary_pro_progress_viewed',
  COMPLIMENTARY_PRO_QUALIFIED: 'complimentary_pro_qualified',
  COMPLIMENTARY_PRO_GRANTED: 'complimentary_pro_granted',
  COMPLIMENTARY_PRO_RENEWED: 'complimentary_pro_renewed',
  COMPLIMENTARY_PRO_EXPIRING_NOTIFIED: 'complimentary_pro_expiring_notified',
  COMPLIMENTARY_PRO_LAPSED: 'complimentary_pro_lapsed',
  COMPLIMENTARY_PRO_REVOKED: 'complimentary_pro_revoked',
  COMPLIMENTARY_PRO_CONVERTED_TO_PAID: 'complimentary_pro_converted_to_paid',
  WORK_WITH_MENUHUNTER_SUBMITTED: 'work_with_menuhunter_submitted',
  SUPPORT_TICKET_CREATED: 'support_ticket_created',
  PRO_UPGRADE_COMPLETED: 'pro_upgrade_completed',
  PRO_RENEWED: 'pro_renewed',
  PRO_CANCELLED: 'pro_cancelled',
  PRO_EXPIRED: 'pro_expired',
  BILLING_ISSUE: 'billing_issue',
  CLAIM_FAILED: 'claim_failed',

  /** Christmas public web / QR (Phase 7). Safe props only. */
  CHRISTMAS_WEB_OFFERING_OPENED: 'christmas_web_offering_opened',
  CHRISTMAS_WEB_CATEGORY_CHANGED: 'christmas_web_category_changed',
  CHRISTMAS_WEB_QR_RESTAURANT_INTERACTION: 'christmas_web_qr_restaurant_interaction',
} as const

export type PostHogEventName = (typeof POSTHOG_EVENTS)[keyof typeof POSTHOG_EVENTS]

/** Global common properties (snake_case). Include source: 'web' on all web events. */
export const POSTHOG_SOURCE = 'web' as const
